// handle border collapse
function compactItemBorder(token, parentCls, options) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? '> *' : '';
  const hoverEffects = ['hover', focus ? 'focus' : null, 'active'].filter(Boolean).map(n => "&:".concat(n, " ").concat(childCombinator)).join(',');
  return {
    ["&-item:not(".concat(parentCls, "-last-item)")]: {
      marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    },
    '&-item': Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 2
      }
    }, focusElCls ? {
      ["&".concat(focusElCls)]: {
        zIndex: 2
      }
    } : {}), {
      ["&[disabled] ".concat(childCombinator)]: {
        zIndex: 0
      }
    })
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? "> ".concat(borderElCls) : '';
  return {
    ["&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item) ").concat(childCombinator)]: {
      borderRadius: 0
    },
    ["&-item:not(".concat(parentCls, "-last-item)").concat(parentCls, "-first-item")]: {
      ["& ".concat(childCombinator, ", &").concat(prefixCls, "-sm ").concat(childCombinator, ", &").concat(prefixCls, "-lg ").concat(childCombinator)]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    ["&-item:not(".concat(parentCls, "-first-item)").concat(parentCls, "-last-item")]: {
      ["& ".concat(childCombinator, ", &").concat(prefixCls, "-sm ").concat(childCombinator, ", &").concat(prefixCls, "-lg ").concat(childCombinator)]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
export function genCompactItemStyle(token) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    focus: true
  };
  const {
    componentCls
  } = token;
  const compactCls = "".concat(componentCls, "-compact");
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token, compactCls, options)), compactItemBorderRadius(componentCls, compactCls, options))
  };
}